<template>
  <div class="pb-5">

        <label for="">locale</label>
        <v-autocomplete
          v-model="menu.locale"
          :items="langIso"
          item-text="name"
          item-value="code"
          outline
          solo
          label="Search Languages"
        >
        </v-autocomplete>


    <div class="menu-items">

      <draggable v-model="menu.call_to_actions" group="menu" @start="drag=true" @end="drag=false" handle=".handel-menu-items">
        <div v-for="(item,index) in menu.call_to_actions">
          <div class="menu-item">
            <menu-item :item="item" :block-list="blockList"></menu-item>
            <div class="menu-item-actions">
              <v-btn
                @click="deleteItem(index)"
                fab small color=""
                class=""
              ><v-icon  color="red">delete_outline</v-icon></v-btn>
              <v-btn  class="handel-menu-items" fab small color=""><v-icon color="#666">height</v-icon></v-btn>
            </div>
          </div>
        </div>
      </draggable>

      <v-btn
        large round flat
        class="primary--text mt-3"
        @click="addItem"
        block
      >
        <v-icon>add_circle_outline</v-icon>
        Add Item
      </v-btn>
    </div>
  </div>
</template>

<script>
  import menuItem from "./menuItem";
  import draggable from 'vuedraggable'
  import common from "../../../../utils/common";
  import langIso from "../../../../utils/lang-iso"
  export default {
    name: "menu",
    components: {
      menuItem,
      draggable
    },
    props: {
      menu: {
        type: Object,
        default: ()=> {
          return {}
        }
      },
      blockList: {
        type: Array,
        default: () => {
          return []
        }
      }
    },
    data() {
      return {
        langIso
      }
    },
    methods: {
      addItem () {
        this.menu.call_to_actions.push({
          type: 'postback',
          title: 'Item name',
          payload: ''
        })
      },
      deleteItem(index) {
        this.menu.call_to_actions.splice(index,1)
      }
    }
  }
</script>

<style lang="scss">

  .menu-item  {
    position: relative;
    width: 100%;
    padding-right: 30px;
    .menu-item-actions{
      position: absolute;
      top: 0;
      right: -20px;
      display: none;
      .v-btn {
        display: block;
        width: 22px;
        height: 22px;
      }
    }
    &:hover .menu-item-actions {
      display: block;
    }
  }

</style>
